import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, inject, input, output, signal, TemplateRef } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivatedRouteServiceMock } from '@vectronic/util';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'vectronic-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss'],
  imports: [CardComponent, MatButton, NgClass, MatIcon, NgTemplateOutlet],
  providers: [{ provide: ActivatedRoute, useClass: ActivatedRouteServiceMock }],
})
export class LeftSidebarComponent {
  router = inject(Router);

  title = input<string>();
  showHeader = input(true);

  sidebarToggle = output<boolean>();

  isLeftSidebarHidden = signal<boolean>(false);

  @ContentChild('headerButtons') headerButtons: TemplateRef<any>;

  toggleLeftSidebarVisibility() {
    this.isLeftSidebarHidden.set(!this.isLeftSidebarHidden());
    this.sidebarToggle.emit(this.isLeftSidebarHidden());
  }

  open(isToggle: boolean) {
    this.isLeftSidebarHidden.set(isToggle);
    this.sidebarToggle.emit(isToggle);
  }
}
